var $d9a3d49db610dd5c$exports = {};
$d9a3d49db610dd5c$exports = {
  "Clear search": "I\u0161valyti ie\u0161k\u0105"
};
export { $d9a3d49db610dd5c$exports as default };